import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function advancedQueryFunc(data) {
  return request({
    url: URL.act.sharedCenter.advancedQueryUrl,
    method: 'post',
    data
  })
}

export function saveFunc(data) {
  return request({
    url: URL.act.sharedCenter.saveUrl,
    method: 'post',
    data
  })
}
export function deleteFunc(data) {
  return request({
    url: URL.act.sharedCenter.deleteUrl,
    method: 'post',
    data
  })
}
export function codeMappingQueryFunc(data) {
  return request({
    url: URL.act.sharedCenter.codeMappingQueryUrl,
    method: 'post',
    data
  })
}
export function getInvoiceTitleListFunc(data) {
  return request({
    url: URL.act.sharedCenter.getInvoiceTitleListUrl,
    method: 'post',
    data
  })
}
export function queryPushLogFunc(params) {
  return request({
    url: URL.act.sharedCenter.queryPushLogUrl,
    method: 'get',
    params
  })
}

// 查青旅推送记录日志
export function queryPushLogFuncQl(params) {
  return request({
    url: URL.act.sharedCenter.queryPushLogUrlQl,
    method: 'get',
    params
  })
}

// 推送暂估单
export function pushPreliminaryFunc(data) {
  return request({
    url: URL.act.sharedCenter.pushPreliminaryUrl,
    method: 'post',
    data
  })
}
export function queryOrderLogFunc(data) {
  return request({
    url: URL.act.sharedCenter.queryOrderLogUrl,
    method: 'post',
    data
  })
}
export function checkPushFunc(data) {
  return request({
    url: URL.act.sharedCenter.checkPushUrl,
    method: 'post',
    data
  })
}
// 暂估单添加费用
export function getAddChargeListFunc(requestBody) {
  return request({
    url: URL.act.sharedCenter.getAddChargeListUrl,
    method: 'post',
    data: requestBody
  })
}
// 自动核销
export function autoWriteOffFunc(params) {
  return request({
    url: URL.act.sharedCenter.autoWriteOffUrl,
    method: 'get',
    params
  })
}
